<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/coach_list' }">教练管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!form.uuid">新增教练</el-breadcrumb-item>
      <el-breadcrumb-item v-else>修改教练</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="form" :rules="rules" label-width="180px" class="form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="证件号" prop="no">
            <el-input v-model="form.no"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="英文名字" prop="nameEnglish">
            <el-input v-model="form.nameEnglish"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号" prop="phoneNo">
            <el-input v-model="form.phoneNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="无犯罪证明到期时间" prop="disclosureDue">
            <el-date-picker
              type="date"
              placeholder="无犯罪证明到期时间"
              v-model="form.disclosureDue"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="急救到期时间" prop="firstAidDue">
            <el-date-picker
              type="date"
              placeholder="急救到期时间"
              v-model="form.firstAidDue"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员费到期时间" prop="memberFeeDue">
            <el-date-picker
              type="date"
              placeholder="会员费到期时间"
              v-model="form.memberFeeDue"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="教练等级1" prop="qualifications1">
            <el-select v-model="form.qualifications1" placeholder="请选择课程等级">
              <el-option label="Snowboard Level 1" value="Snowboard Level 1"></el-option>
              <el-option label="Snowboard Level 2" value="Snowboard Level 2"></el-option>
              <el-option label="Snowboard Level 3" value="Snowboard Level 3"></el-option>
              <el-option label="Ski Level 1" value="Ski Level 1"></el-option>
              <el-option label="Ski Level 2" value="Ski Level 2"></el-option>
              <el-option label="Ski Level 3" value="Ski Level 3"></el-option>
              <el-option label="Mountain Safety" value="Mountain Safety"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="cpd到期时间1" prop="cpdDue1">
              <el-date-picker
                type="date"
                placeholder="cpd到期时间1"
                v-model="form.cpdDue1"
                value-format="yyyy-MM-dd"
                style="width: 100%;">
              </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="教练等级2" prop="qualifications2">
            <el-select v-model="form.qualifications2" placeholder="请选择课程等级">
              <el-option label="Snowboard Level 1" value="Snowboard Level 1"></el-option>
              <el-option label="Snowboard Level 2" value="Snowboard Level 2"></el-option>
              <el-option label="Snowboard Level 3" value="Snowboard Level 3"></el-option>
              <el-option label="Ski Level 1" value="Ski Level 1"></el-option>
              <el-option label="Ski Level 2" value="Ski Level 2"></el-option>
              <el-option label="Ski Level 3" value="Ski Level 3"></el-option>
              <el-option label="Mountain Safety" value="Mountain Safety"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="cpd到期时间2" prop="cpdDue2">
            <el-date-picker
              type="date"
              placeholder="cpd到期时间2"
              v-model="form.cpdDue2"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="教练等级3" prop="qualifications3">
            <el-select v-model="form.qualifications3" placeholder="请选择课程等级">
              <el-option label="Snowboard Level 1" value="Snowboard Level 1"></el-option>
              <el-option label="Snowboard Level 2" value="Snowboard Level 2"></el-option>
              <el-option label="Snowboard Level 3" value="Snowboard Level 3"></el-option>
              <el-option label="Ski Level 1" value="Ski Level 1"></el-option>
              <el-option label="Ski Level 2" value="Ski Level 2"></el-option>
              <el-option label="Ski Level 3" value="Ski Level 3"></el-option>
              <el-option label="Mountain Safety" value="Mountain Safety"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="cpd到期时间3" prop="cpdDue3">
            <el-date-picker
              type="date"
              placeholder="cpd到期时间3"
              v-model="form.cpdDue3"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="黑名单" prop="type">
            <el-radio-group v-model="form.isBlack">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="onSubmit(1)" v-if="!form.uuid" :loading="loading">立即创建</el-button>
        <el-button type="primary" @click="onSubmit(2)" v-else :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapGetters } from 'vuex';
  import { trimString, isPhoneNo } from '@/common/js/util';
  import { coachUtil } from '@/api/coach';

  export default {
    data() {
      return {
        form: {
          no: '',
          name: '',
          nameEnglish: '',
          phoneNo: '',
          disclosureDue: '',
          firstAidDue: '',
          memberFeeDue: '',
          qualifications1: '',
          cpdDue1: '',
          qualifications2: '',
          cpdDue2: '',
          qualifications3: '',
          cpdDue3: '',
          isBlack: 0
        },
        rules: {
          no: [
            { required: true, message: '请输入证件号', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          nameEnglish: [
            { required: true, message: '请输入英文名字', trigger: 'blur' }
          ],
          phoneNo: [
            { required: true, message: '请输入手机号', trigger: 'blur' }
          ],
          disclosureDue: [
            { required: true, message: '请选择证明到期时间', trigger: 'blur' }
          ],
          firstAidDue: [
            { required: true, message: '请选择急救到期时间', trigger: 'blur' }
          ],
          memberFeeDue: [
            { required: true, message: '请选择会员到期时间', trigger: 'blur' }
          ],
          qualifications1: [
            { required: true, message: '请输入教练等级1', trigger: 'blur' }
          ],
          cpdDue1: [
            { required: true, message: '请选择cpd到期时间1', trigger: 'blur' }
          ],
          isBlack: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ]
        },
        loading: false
      };
    },
    mounted() {
      if (this.$route.params.id) {
        this.form = Object.assign({}, this.form, this.coach);
      }
    },
    methods: {
      onSubmit(type) {
        if (!this.form.no || !trimString(this.form.no)) {
          this.$message.warning('请输入证件号');
          return;
        }
        if (!this.form.name || !trimString(this.form.name)) {
          this.$message.warning('请输入姓名');
          return;
        }
        if (!this.form.nameEnglish || !trimString(this.form.nameEnglish)) {
          this.$message.warning('请输入英文名字');
          return;
        }
        if (!this.form.phoneNo || !trimString(this.form.phoneNo)) {
          this.$message.error('手机号不能为空！');
          return;
        }
        if (!isPhoneNo(this.form.phoneNo)) {
          this.$message.error('请输入正确的手机号！');
          return;
        }
        if (!this.form.disclosureDue || !trimString(this.form.disclosureDue)) {
          this.$message.warning('请选择证明到期时间');
          return;
        }
        if (!this.form.firstAidDue || !trimString(this.form.firstAidDue)) {
          this.$message.warning('请选择急救到期时间');
          return;
        }
        if (!this.form.memberFeeDue || !trimString(this.form.memberFeeDue)) {
          this.$message.warning('请选择会员到期时间');
          return;
        }
        if (!this.form.qualifications1 || !trimString(this.form.qualifications1)) {
          this.$message.warning('请输入教练等级1');
          return;
        }
        if (!this.form.cpdDue1 || !trimString(this.form.cpdDue1)) {
          this.$message.warning('请选择cpd到期时间1');
          return;
        }
        this.loading = true;
        this.form.userId = this.user.userId;
        switch (type) {
          case 1:
            coachUtil(this.form, 1).then((res) => {
              this.loading = false;
              if (res.rspCode === 0) {
                this.$message.success('新增教练成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.rspDesc);
              }
            }).catch(e => {
              this.loading = false;
            });
            break;
          case 2:
            coachUtil(this.form, 2).then((res) => {
              this.loading = false;
              if (res.rspCode === 0) {
                this.$message.success('保存教练成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.rspDesc);
              }
            }).catch(e => {
              this.loading = false;
            });
            break;
        }
      }
    },
    computed: {
      ...mapGetters([
        'coach',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
</style>